module.exports = __webpack_public_path__ + "44546ff9ca9f7b7611d18af4059d955a.png";